import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import { Button } from "@/view/components/ui/button";
import { Spinner } from "./ui/spinner";

interface ConfirmationModalProps {
  title: string;
  onConfirm: () => void;
  Content: JSX.Element;
  isLoading?: boolean;
  confirmDisabled?: boolean;
}

export function ConfirmationModal({
  title,
  onConfirm,
  Content,
  isLoading,
  confirmDisabled,
}: ConfirmationModalProps) {
  return (
    <DialogContent className="sm:max-w-md">
      <DialogHeader className="border-b pb-4">
        <DialogTitle className="text-xl font-semibold text-black01">
          {title}
        </DialogTitle>
      </DialogHeader>

      <DialogDescription className="text-base text-black04">
        {Content}
      </DialogDescription>

      <DialogFooter>
        <DialogClose>
          <Button className="bg-gray02 text-primary hover:bg-gray01">
            Cancelar
          </Button>
        </DialogClose>
        <Button
          disabled={isLoading || confirmDisabled}
          className="text-white"
          onClick={onConfirm}
        >
          {isLoading ? <Spinner className="text-white" /> : "Confirmar"}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
}
